import { render, staticRenderFns } from "./agreeDialog.vue?vue&type=template&id=3f8b54c5&scoped=true&"
import script from "./agreeDialog.vue?vue&type=script&lang=js&"
export * from "./agreeDialog.vue?vue&type=script&lang=js&"
import style0 from "./agreeDialog.vue?vue&type=style&index=0&id=3f8b54c5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8b54c5",
  null
  
)

export default component.exports